import styles from './Header.module.css';
import * as React from 'react';
export default function MenuItemComponent(_a) {
    var item = _a.item, close = _a.close;
    return (React.createElement(React.Fragment, null, item.kind === 'link' ? (React.createElement("a", { href: item.url, className: styles.menuItem }, item.title)) : (React.createElement("button", { onClick: function () {
            item.action();
            close();
        }, className: styles.menuItem }, item.title))));
}
